module.exports = __webpack_public_path__ + "static/img/pw.2084daff.svg";